import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import logo from "../assets/logo_icon.png";

export default function AboutUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<div 
					className="MainBodySection bg-surface"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row text-center">
							<div className="col-md-12">
								<img src={logo} height={100} />
								<h3 className="main-section-title">Tanzania Children Hope Innovations (TCHI)</h3>
							</div>
							<div 
								className="col-md-9 m-auto p-3"
								style={{
									textAlign: "justify"
								}}
							>
								<h5 className="lh-sm">
									Tanzania Children Hope Innovations (TCHI) is a registered non-governmental organization located in the southern highlands of Tanzania, with its headquarters in Mbeya. Officially established in 2023 under registration number 00NGO/R/5391, TCHI was founded by committed Tanzanian citizens who recognized the urgent and growing challenges faced by vulnerable groups in society. These groups include children, adolescents, youth, women, and the elderly, many of whom are disproportionately affected by poverty, HIV/AIDS, orphanhood, limited access to education and healthcare, and social exclusion.
									<br />
									<br />
									From its inception, TCHI has been driven by the belief that community-based solutions are the key to sustainable change. The organization therefore pioneered an innovative community-based sponsorship model where vulnerable children and families are directly supported by local sponsors within their own communities. This approach not only reduces dependence on external donors but also builds a sense of ownership, accountability, and solidarity among community members. It enables sponsors and beneficiaries to interact directly, ensuring transparency and personalized support that truly meets individual needs.
								</h5>
							</div>
						</div>
					</div>
				</div>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}